export const FeedbackLink = "https://forms.office.com/r/xrDhvNcL95";
export const UserGuideLink = "https://docs.google.com/document/d/1RIX96QKFxvvuQ-3BQP0uwedc9nt5tcfLTtMPUx0pgvY/edit?usp=sharing";
export const ChangelogLink = "https://help.zsoftware.com.au/hc/en-us/sections/34332729832973-Release-Notes";
export const CurrentFreedomLink = "https://zfreedom.com.au";